import { useState, useEffect } from "react";
import { RESPONSE_STATUS } from "../utils/constants.js";
import { apiGetLead360 } from "../network/service.js";
import { cssHost } from "../utils/config.js";

export const injectMainCss = (setCssLoad = () => {}) => {
  setCssLoad({ responseStatus: RESPONSE_STATUS.requestPending });
  try {
    // The new (Vite) build loads its own hashed CSS via the casalead360entry
    // loader, so skip the legacy initialize360.css injection there. Detected
    // via LEAD360_ASSET_VERSION, which only the new build sets — so the legacy
    // Parcel build keeps injecting initialize360.css exactly as before.
    if (cssHost && !process.env.LEAD360_ASSET_VERSION) {
      const link2 = document.createElement("link");
      link2.href = `${cssHost}/initialize360.css`;
      link2.rel = "stylesheet";
      document.head.appendChild(link2);
    }
    setCssLoad({ responseStatus: RESPONSE_STATUS.requestFullfilled });
  } catch (error) {
    console.error(error);
    setCssLoad({ responseStatus: RESPONSE_STATUS.requestRejected });
  }
};

const initializeLead360 = async (setLead360) => {
  try {
    setLead360({
      responseStatus: RESPONSE_STATUS.requestPending,
      data: null,
    });
    const response = await apiGetLead360();
    if (response.status === 200) {
      if (!response.data?.leadPage) {
        throw new Error("Lead360 config not found");
      }
      setLead360({
        responseStatus: RESPONSE_STATUS.requestFullfilled,
        data: response.data,
      });
    } else {
      throw new Error("Failed to fetch lead360");
    }
  } catch (error) {
    console.error(error);
    setLead360({
      responseStatus: RESPONSE_STATUS.requestRejected,
      data: null,
    });
    window.lead360HelperUtils?.handleFallback();
  }
};
const getWidgetMap = (lead360) => {
  const widgetMap = {}; 
  lead360?.data?.leadPage?.widgets?.forEach((widget) => {
    widgetMap[widget.id] = widget;
  });
  return widgetMap;
};
const useInitializeLead360 = () => {
  const [lead360, setLead360] = useState({
    responseStatus: RESPONSE_STATUS.requestPending,
    data: null,
  });
  const [cssLoad, setCssLoad] = useState({
    responseStatus: RESPONSE_STATUS.requestPending,
  });
  useEffect(() => {
    initializeLead360(setLead360);
    injectMainCss(setCssLoad);
  }, []);
  return {
    loading:
      lead360.responseStatus === RESPONSE_STATUS.requestPending ||
      cssLoad.responseStatus === RESPONSE_STATUS.requestPending,
    error:
      lead360.responseStatus === RESPONSE_STATUS.requestRejected ||
      cssLoad.responseStatus === RESPONSE_STATUS.requestRejected,
    pageConfig: lead360?.data?.leadPage?.config,
    widgetMap: getWidgetMap(lead360),
    initialize: initializeLead360,
  };
};

export default useInitializeLead360;
